<p>candidature-form-simplify works!</p>
